import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  Stack,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { useQuery } from "@apollo/client";
//Icons
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
//Srcs
import "../../Style/dialogstyle.scss";
import EmptyImge from "../../Assets/empty-image.png";
import { SELECT_MATERIAL } from "../../Schema/Material";
import ItemMaterialUnit from "./ItemMaterialUnit";

export default function ListItem({
  handleUpdateList,
  handleDeleteList,
  handleAddList,
  requiredField,
  listItems,
  groupId,
}) {
  const [listMaterialOptions, setMeterialOptions] = useState([]); 
  const [materialId, setMaterialId] = useState("");
  const [checkMaterial, setCheckMaterial] = useState(false);
  const [checkUnit, setCheckUnit] = useState(false);

  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse: true,
      groupId: groupId,
      sectionId: null,
    },
    onCompleted: ({ selectMaterial }) => {
      // console.log("selectMaterial::", selectMaterial)
      if (selectMaterial?.length > 0) {
        const materialData = selectMaterial?.map((e) => {
          return {
            id: e?._id,
            title: 'ISBN: '+ e?.isbm +" - "+e?.materialKhName,
          };
        });
        setMeterialOptions(materialData);
      } else {
        setMeterialOptions([]);
      }
    },
    onError: (error) => {
      // setLoading(true);
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [checkMaterial, groupId]); 

   

  return (
    <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
      <Stack
        direction="row"
        spacing={1}
        mb={1}
        bgcolor="#f5faff"
        paddingX="2px"
        paddingY="5px"
        borderRadius="8px"
      >
        <Typography className="field-title-list" sx={{ width: "10%" }}>
          រូបភាព
        </Typography>
        <Typography className="field-title-list" sx={{ width: "60%" }}>
          ឈ្មោះសម្ភារៈ
        </Typography>
        <Typography className="field-title-list" sx={{ width: "15%" }}>
          ឯកតា
        </Typography>
        <Typography className="field-title-list" sx={{ width: "10%" }}>
          ចំនួន
        </Typography>
        <Stack width="5%" direction="column" justifyContent="center">
          <Box textAlign="center">
            <IconButton onClick={handleAddList}>
              <AddCircleIcon sx={{ color: "#2e3192" }} />
            </IconButton>
          </Box>
        </Stack>
      </Stack>
      {listItems?.map((e) => {
        // console.log("e::::", e);
        return (
          <Stack direction="row" spacing={1} key={e?.key}>
            <Stack width="10%">
              <img
                style={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  width: "80%",
                }}
                src={
                  e?.listMaterialUnitId?.imageSrc
                    ? e?.listMaterialUnitId?.imageSrc
                    : EmptyImge
                }
              />
            </Stack>
            <Stack width="60%" direction="column" justifyContent="center">
              <Autocomplete
                value={e.materialId}
                options={listMaterialOptions}
                onChange={(event, val) => {
                  setCheckMaterial(true);
                  handleUpdateList(e.key, val, "materialId");
                  setMaterialId(val?.id);
                }}
                getOptionLabel={(option) =>
                  option?.title === undefined ? "ជ្រើសរើស" : option?.title
                }
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={"ជ្រើសរើស"}
                    error={
                      (requiredField && e?.materialId?.id === undefined) ||
                      (requiredField && e?.materialId?.id === "")
                        ? true
                        : false
                    }
                  />
                )}
              />
            </Stack> 
            <ItemMaterialUnit  
              e={e}
              materialId={e?.materialId?.id}
              setCheckUnit={setCheckUnit} 
              handleUpdateList={handleUpdateList}
              requiredField={requiredField}   
              checkUnit={checkUnit}
            /> 
            <Stack width="10%" direction="column" justifyContent="center">
              <TextField
                className="text-field"
                fullWidth
                size="small"
                type="number"
                placeholder="បរិមាណ"
                onFocus={(e) => e?.target?.select()}
                value={e?.qty}
                onChange={(val) =>
                  handleUpdateList(e.key, val.target.value, "qty")
                }
                error={
                  (requiredField && e?.qty === 0) ||
                  (requiredField && e?.qty < 0)
                }
                inputProps={{
                  min: 0,
                }}
              />
            </Stack>

            <Stack width="5%" direction="column" justifyContent="center">
              <IconButton
                sx={{ width: "40px", height: "40px" }}
                onClick={() => handleDeleteList(e.key)}
              >
                <RemoveCircleIcon sx={{ color: "red" }} />
              </IconButton>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
}
